import { useTranslation } from "react-i18next";

const OrderReviewDeliveryAddress = (props: any) => {
  const { t } = useTranslation();
  
  const formatAddressLine = (parts: (string | undefined)[], separator = ', ') => {
    const validParts = parts.filter(part => part && part.trim() !== '');
    return validParts.join(separator);
  };

  const renderAddress = () => {
    const { addressDetails } = props;
    if (!addressDetails) return null;

    const addressLines = [
      addressDetails.address1,
      addressDetails.address2,
      addressDetails.landmark,
      formatAddressLine([
        addressDetails.areaName,
        addressDetails.subDistrictName,
      ]),
      formatAddressLine([
        addressDetails.districtName,
        addressDetails.stateName,
        addressDetails.countryName,
        addressDetails.zipcode ? `-${addressDetails.zipcode}` : ''
      ], ' ')
    ].filter(line => line && line.trim() !== '');

    return (
      <>
        {addressLines.map((line, index) => (
          <p key={`address-line-${index}`} className="mb-0">
            {line}
            {index !== addressLines.length - 1 ? ',' : '.'}
          </p>
        ))}
      </>
    );
  };

  return (
    <>
    <div className="text-900small">
      <p className="font-bold">{t("ordersummary_delivery_address")}</p>
      {renderAddress()}
      <br />
      <p className="font-bold">
      {t("ordersummary_payment_mode")} :{" "}
      {props.addressDetails.paymentModeName}
      </p>
    </div>
    </>
  );
};

export default OrderReviewDeliveryAddress;